import { BAND } from "./pulse";

// The dot: colour + a ping that beats faster the worse things are. Quiet (no ping) when the
// spike is marked Expected, when the month is too quiet to score, or when Pulse is off.
export function PulseDot({ band = "quiet", quiet = false, size = 12, testid }) {
  const b = BAND[band] || BAND.quiet;
  const ping = !quiet && b.ping;
  return (
    <span data-testid={testid} data-band={band} className="relative inline-flex shrink-0" style={{ width: size, height: size }} title={b.word}>
      {ping && (
        <span className="absolute inset-[-5px] rounded-full border-2 pulse-ring" style={{ borderColor: b.dot, "--pulse-t": b.ping }} />
      )}
      <span className="relative inline-flex rounded-full w-full h-full" style={{ backgroundColor: b.dot }} />
    </span>
  );
}

export function PulseWord({ band = "quiet", testid }) {
  const b = BAND[band] || BAND.quiet;
  return <span data-testid={testid} className={`text-[11px] font-extrabold uppercase tracking-[0.04em] ${b.text}`}>{b.word}</span>;
}
